<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-content-wrapper">

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Lead Form Consent (CCPA)
        <i class="pi pi-info-circle"
           pTooltip="Toggle to require visitor consent on lead forms for contact permissions, as mandated for certain accounts under the California Consumer Privacy Act (CCPA). This act provides privacy rights and consumer protections for residents of California."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="leadFormConsentEnabled"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Lead Form Consent Text
        <i class="pi pi-info-circle"
           pTooltip="Edit the text displayed for CCPA consent on lead forms."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputText rows="6" class="tall-textarea" formControlName="leadFormConsentText"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Detailed Lead Form Consent (TCPA)
        <i class="pi pi-info-circle"
           pTooltip="Toggle to require visitor consent on lead forms for marketing permissions, as mandated for certain accounts under the Telephone Consumer Protection Act (TCPA). This act regulates telemarketing calls, auto-dialed calls, prerecorded calls, text messages, and unsolicited faxes."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="detailedLeadFormConsentEnabled"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Detailed Lead Form Consent Text
        <i class="pi pi-info-circle"
           pTooltip="Edit the text displayed for TCPA consent on lead forms."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputText rows="6" class="tall-textarea" formControlName="detailedLeadFormConsentText"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        New Form Main CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Changes the main call-to-action text shown on lead forms for New Offer Sets."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="newFormMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Used Form Main CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Changes the main call-to-action text shown on lead forms for Used Offer Sets."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="usedFormMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Require Postal Code on Lead Forms
        <i class="pi pi-info-circle"
           pTooltip="Adds a postal code field to lead forms and requires it to be completed before submission."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="leadsNeedPostalCode"></p-toggleswitch>
    </div>
  </div>
</form>
